import React from 'react';
import { TabBar, TabBarOnActivateEventT, Tab } from '@rmwc/tabs';
import '@rmwc/tabs/styles';
import { nanoid } from 'nanoid';
import classNames from 'classnames';

interface IItemRow {
  subTitle: string;
  description: string;
}

interface ItemType {
  title?: string;
  rows: IItemRow[];
}

interface Props {
  tabsItem: ItemType[];
  tabsClass?: string;
}

export const HomePageTab = ({ tabsItem, tabsClass }: Props) => {
  const [activeIndex, setActiveIndex] = React.useState(0);

  const onActivateFc = (evt: TabBarOnActivateEventT) => {
    setActiveIndex(evt.detail.index);
  };

  return (
    <div className={`feature-tabs ${tabsClass}`}>
      <div>
        <TabBar activeTabIndex={activeIndex} onActivate={(evt) => onActivateFc(evt)}>
          {tabsItem.map(({ title }, index) => {
            return (
              <Tab
                onClick={() => setActiveIndex(index)}
                focusOnActivate={false}
                className={index === activeIndex ? 'tabs-row-item active' : 'tabs-row-item'}
                key={nanoid()}
              >
                {title}
              </Tab>
            );
          })}
        </TabBar>
      </div>
      <div className="tabs-row-panels" key={nanoid()}>
        {tabsItem.map((item, index) => (
          <table key={nanoid()} className={classNames({ hidden: activeIndex !== index })}>
            <tbody>
              {item.rows.map(({ subTitle, description }) => {
                return (
                  <tr key={subTitle} className={`tab-${activeIndex}`}>
                    <td className="title">
                      <h6 className=" body-1 strong">{subTitle}</h6>
                    </td>
                    <td className="content">
                      <div className="body-1">{description}</div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ))}
      </div>
    </div>
  );
};
